import cssVars from 'css-vars-ponyfill';

if (window.themeColor) {
    cssVars({ variables: { 'theme-color': window.themeColor } });
    document.querySelectorAll('[data-theme-color]').forEach(el => {
        el.setAttribute(el.dataset.themeColor, window.themeColor);
    });
}
